// extracted by mini-css-extract-plugin
export default {"classroomCard":"ClassroomBoxTeacher_classroomCard__gnVm7"};